export default {
  species: [
    "Humpback Whale",
    "Fin Whale",
    "Orca",
    "Steller Sea Lion",
    "Harbour Seal",
    "Elephant Seal",
    "Dalls Porpoise",
    "Pacific White Sided Dolphin",
    "Whale of Unknown Species",
    "Other",
  ],
  incidentType: ["Entanglement", "Ship Strike", "Stranding", "Unknown", "Other"],
  injuryLocation: [
    "Jaws",
    "Flippers",
    "Dorsal Body (the animals back)",
    "Ventral Body (the animals stomach)",
    "Fluke/Tail",
    "Other",
  ],
  travDirection: [
    "North",
    "North-East",
    "East",
    "South-East",
    "South",
    "South-West",
    "West",
    "North-West",
    "Unknown/Not Travelling",
  ],
  shortMonths: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],
  sightingBodyFeature: {
    FLUKE: "FL",
    FRONT_FLUKE: "F-FL",
    LEFT_DORSAL: "LD",
    RIGHT_DORSAL: "RD",
    DORSAL_BODY: "DB",
    EYEPATCH: "EP",
  },
  sightingBehaviour: {
    RESTING: "RE",
    TRAVELLING: "TR",
    MILLING: "MI",
    BUBBLE_NET_FEEDING: "BNF",
    SOCIAL: "SOC",
    UNKNOWN_FEEDING: "FE",
    KELP_ROLLING: "KR",
    JOINS: "J",
    SLEEPING: "SL",
    BLOWING_BUBBLES: "BUB",
    MILLING_FEEDING: "MI-FE",
    PLAYING: "PLAY",
    DEPART: "DP",
    LARGE_SPLIT_GROUP_1: "LG-SP-1", // Potential further processing needed if we change this to add group numbers to the end, that isn't how the current data works though
    LARGE_SPLIT_GROUP_2: "LG-SP-2", // Potential further processing needed if we change this to add group numbers to the end, that isn't how the current data works though
    SPYHOP: "SH",
    LUNGE_FEEDING: "LU-FE",
    FAST_TRAVEL: "FTR",
    SLOW_TRAVEL: "STR",
    FISHING: "FISH",
    PORPOISING: "P",
    FOOD_SHARING: "FS",
    INTER_SPECIES_INTERACTION: "ISI",
    IDLE_VESSEL: "I",
    FLICK_FEEDING: "F-FEED",
    PEC_SLAP: "PS",
    TAIL_SLAP: "TS",
    HEADLOB: "HL",
    BREACH: "BR",
    TAIL_LOB: "TL",
  },
  sightingWeather: {
    SUNNY: "S",
    PARTLY_SUNNY: "PS",
    OVERCAST: "OC",
    LIGHT_RAIN: "LR",
    RAIN: "R",
    FOG: "F",
    SUNSET: "SS",
    SUNRISE: "SR",
  },
  whaleType: {
    ADULT: "A",
    FEMALE: "F",
    MOTHER: "M",
    MALE: "MALE",
    JUVENILE: "J",
    CALF: "C",
    SUBADULT: "SA",
  },
  sightingSpecies: {
    HUMPBACK_WHALE: "HW",
    FIN_WHALE: "FW",
    NORTHERN_RESIDENT_KILLER_WHALE: "NRKW",
    TRANSIENT_KILLER_WHALE: "BIGGS",
    UNKNOWN_ORCA: "Oo",
    DALLS_PORPOISE: "DP",
    HARBOUR_SEAL: "HS",
    STELLAR_SEA_LION: "SSL",
    ELEPHANT_SEAL: "ES",
    PACIFIC_WHITE_SIDED_DOLPHIN: "PWD",
    SMALL_RECREATIONAL_VESSEL: "SR",
    LARGE_RECREATIONAL_VESSEL: "LR",
    RESEARCH_VESSEL: "R",
    GITGAAT_GUARDIAN_VESSEL: "GITGAAT",
  },
  sightingTypes: [
      "Land",
      "Marine",
      "Unknown",
  ],
  ecotype: [
    "Resident",
    "Transient",
    "Offshore",
  ],
  maternalConfidence: ["Known", "Probable", "Possible"],
  orcaClan: {
    NORTHERN_RESIDENT: ["A", "G", "R"],
    ALL_RESIDENT: ["A", "G", "R", "J"],
  },
  clanPods: {
    A: ["A1", "A4", "A5", "B1", "C1", "D1", "H1", "I1", "I2", "I18"],
    G: ["G1", "G12", "I11", "I31"],
    R: ["R1", "W1"],
    J: ["J", "K", "L"],
  },
  knownLandSightingLocations: { // Approximated to geographical features, town centers, and islands where necessary
    FIN_ISLAND: {
      lat: "53.264",
      lon: "-129.351",
      in_list: true,
      to_display: true
    },
    WHALE_POINT: {
      lat: "53.1",
      lon: "-129.2",
      in_list: true,
      to_display: true
    },
    THE_WALL: { // Wall Islands seems more likely than the Wall Islets further south
      lat: "52.8581",
      lon: "-129.3413",
      in_list: true,
      to_display: true
    },
    HARTLEY_BAY: {
      lat: "53.423056",
      lon: "-129.247778",
      in_list: true,
      to_display: false
    },
    ORCA_LAB: {
      lat: "50.5562",
      lon: "-126.6658",
      in_list: true,
      to_display: false
    },
    PRINCE_RUPERT: {
      lat: "54.3150",
      lon: "-130.3220",
      in_list: true,
      to_display: false
    },
    VANCOUVER: {
      lat: "49.2827",
      lon: "-123.1207",
      in_list: true,
      to_display: false
    },
  }
};
